import {IOptionItem} from "@/models";

export const languages: IOptionItem[] = [
  {label: '한국어', value: 'ko-KR'},
  {label: 'English', value: 'en-US'},
];
export const menuLanguages: IOptionItem[] = [
  {label: 'KO', value: 'ko-KR'},
  {label: 'EN', value: 'en-US'},
];